<template>
  <div>
    <div style="margin-bottom: 10px;">
      <CustCard
        :title="$l('form_header_contact') || '客户联系人'"
        :desc="$l('form_desc_contact') || '客户方相关联系人信息'"
      >
        <CustContact :custCode="custCode" />
      </CustCard>
    </div>
    <div class="d-flex">
      <div style="margin-right: 10px;width: 50%;">
        <CustCard
          :title="$l('form_header_category') || '客户品类'"
          :desc="$l('form_desc_category') || '客户主要产品分类'"
        >
          <CustCategory :custCode="custCode" />
        </CustCard>
      </div>
      <div style="width: 50%;">
        <CustCard
          :title="$l('form_header_brand') || '客户品牌'"
          :desc="$l('form_desc_brand') || '客户主要产品品牌'"
        >
          <CustBrand :custCode="custCode" />
        </CustCard>
      </div>
    </div>
  </div>
</template>

<script>
import CustContact from '../cust-contact'
import CustCategory from '../cust-category'
import CustBrand from '../cust-brand'
import CustCard from '../cust-card'
export default {
  components: { CustContact, CustCategory, CustBrand, CustCard },
  props: { custCode: { type: String, default: '' } },
}
</script>
